import script from "./AdminView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminView.vue?vue&type=script&setup=true&lang=ts"

import "./AdminView.vue?vue&type=style&index=0&id=3baad6e0&lang=css"

const __exports__ = script;

export default __exports__